const FETCH_CLASSROOMS_START = 'FETCH_CLASSROOMS_START'
const FETCH_CLASSROOMS_DATA = 'FETCH_CLASSROOMS_DATA'
const FETCH_HEADER_CLASSROOMS_DATA = 'FETCH_HEADER_CLASSROOMS_DATA'

export {
  FETCH_CLASSROOMS_START,
  FETCH_CLASSROOMS_DATA,
  FETCH_HEADER_CLASSROOMS_DATA
}
